var render = function render(){var _vm=this,_c=_vm._self._c;return _c('symbol',{attrs:{"id":`${_vm.prefix}plus-17`,"viewBox":"0 0 17 17"}},[_c('circle',{staticClass:"sign",attrs:{"cx":"8.5","cy":"8.5","r":"8"}}),_c('line',{staticClass:"sign",attrs:{"x1":"8.5","y1":"5","x2":"8.5","y2":"12"}}),_c('line',{staticClass:"sign",attrs:{"x1":"5","y1":"8.5","x2":"12","y2":"8.5"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }